<template>
    <div>
        <h3>Resultados Globais</h3>
        <eleicoes-estatisticas-globais all/>
        <graficos-colunas :items="resultados"/>
        <p v-for="note in notes" :key="note">* {{note}}</p>
        <eleicoes-estatisticas-invalidos/>
        <eleicoes-copyrights/>
    </div>
</template>

<script>
import { sort } from '@/core/utils'
import utils from '@/widgets/eleicoes/utils'

export default {
    computed: {
        resultados() {
            if(!this.$state.resultados) return;
            let res = {
                mandatos: [],
                percent: []
            };
            this.$state.resultados.forEach(item => {
                if(item.mandatos && parseInt(item.mandatos)) res.mandatos.push({
                    ...item,
                    bg: utils.cor(item.opcao)
                });
                else if(item.percent_votantes && parseInt(item.percent_votantes)) res.percent.push({
                    ...item,
                    bg: utils.cor(item.opcao)
                });
            });
            res.final = [...sort(res.mandatos, 'percent_votantes', true, true), ...sort(res.percent, 'percent_votantes', true, true)];
            if(res.final.length > 9) res.final.length = 9;
            return res.final;
        }, 
        notes() {
            if(!this.resultados || !this.resultados.length) return [];
            let notes = [];
            this.resultados.forEach(item => {
                if(!item.note || notes.includes(item.note)) return;
                notes.push(item.note);
            });
            return notes;
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    text-align: center;
}
p {
    color: var(--base-medium-color);
    font-size: .7rem;
    margin-top: 1rem;
    display: block;
    clear: both;
	text-align: center;
	margin-bottom: 2rem;
}
</style>